module.exports = __webpack_public_path__ + "img/hwy.49b190e0.png";